import { IconButton, IconButtonProps } from '@mui/material';

import PencilEdit from '../../../assets/icons/PencilEdit';
import colors from '../../../constants/colors';

const EditButton = <C extends React.ElementType>({
  sx,
  ...props
}: IconButtonProps<C, { component?: C }>) => {
  return (
    <IconButton
      disableRipple
      {...props}
      sx={{
        '&:focus': {
          outline: `solid 2px ${colors.csaaSpectrumBlue50}`,
          outlineOffset: '4px',
          borderRadius: '50%',
          backgroundColor: 'inherit',
        },
        ...sx,
      }}
    >
      <PencilEdit />
    </IconButton>
  );
};

export default EditButton;
